export default __webpack_public_path__ + "static/media/custom-card.f52bbb8e.jpg";